export const selectCandidateByIdIsLoading = (state) =>
  state?.contacts?.candidate?.isLoading;
export const selectCandidateById = (state) => state?.contacts?.candidate?.data;
export const selectCandidateByIdFailed = (state) =>
  state?.contacts?.candidate?.error;
export const selectScheduledConversationsIsLoading = (state) =>
  state?.contacts?.scheduledConversations?.isLoading;
export const selectScheduledConversations = (state) =>
  state?.contacts?.scheduledConversations?.data;

export const selectSimilarContactsIsLoading = (state) =>
  state?.contacts?.similarContacts?.isLoading;
export const selectSimilarContacts = (state) =>
  state?.contacts?.similarContacts?.data;

export const selectContactActivitiesIsLoading = (state) =>
  state?.contacts?.activities.isLoading;
export const selectContactActivities = (state) =>
  state?.contacts?.activities.data;
export const selectContactActivitiesMeta = (state) =>
  state?.contacts?.activities?.meta;
export const selectContactActivitiesPage = (state) =>
  state?.contacts?.activities?.pagination?.page;

export const selectContactOutreachesIsLoading = (state) =>
  state?.contacts?.outreaches.isLoading;
export const selectContactOutreaches = (state) =>
  state?.contacts?.outreaches.data;

export const selectContactConversationsIsLoading = (state) =>
  state?.contacts?.conversations.isLoading;
export const selectContactConversations = (state) =>
  state?.contacts?.conversations.data;

export const selectContactsFilter = (state) => state?.contacts?.filters;
export const selectContactsSearchTerm = (state) =>
  state?.contacts?.search?.term;
export const selectContactsSort = (state) => state?.contacts?.sort;
export const selectContactsPage = (state) => state?.contacts?.pagination;

export const selectUserFiltered = (state) =>
  state?.contacts?.filters?.changed || state?.contacts?.search?.term;
